import React, { ReactNode, useState } from "react";
import { HeadersRoutes } from "../header/HeaderOptions";

export interface INavMenuOption {
    Title: string,
    SubTitle: string,
    Image: ReactNode,
    URL: string,
    Help: string
}



export function useHeaderOptions() {

    const [options, _] = useState<INavMenuOption[]>(HeadersRoutes.GetRoutes().map(s => ({
                Image: <i className={s.ImageClass}></i>,
                Title: s.Title,
                SubTitle: s.SubTitle,
                URL: s.URL,
                Help: s.Help 
            })))

    return options;
}